import Select from "react-select";
import ContentPage from "../../Content";
import { LineChart,Line,XAxis,YAxis,Tooltip,ResponsiveContainer,CartesianGrid,Area,AreaChart, PieChart, Pie, Legend, Cell, BarChart, Bar } from "recharts";
import { useContext, useEffect, useState } from "react";
import axios from "axios";
import CustomerStyle from "../../../utils/customerStyle";
import BaseUrl from "../../../utils/BaseUrl";
import separateNumber from "../../../utils/separateur";
import SwalTopEnd from "../../../utils/swal_top_end";
import ExportExcel from "../../../utils/ExcelExport";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../../utils/User_check";
import can from "../../../utils/Can";

const url = BaseUrl();
const customerStyle = CustomerStyle();
function MomoCommercialPage(){

      const [TotalAirtime,setTotalAirtime] = useState(0);
      const [TotalBundle,setTotalBundle] = useState(0);
      const [TotalCashBack,setTotalCashBack] = useState(0);
      const [nbreCashOut,setNbreCashout] = useState(0);
      const [venteSerie,setVenteSerie] = useState([]);
      const [vendeurEvd,setVendeurEvd] = useState([]);
      const [AllvendeurEvd,setAllVendeurEvd] = useState([]);
      const [commerciaux,setCommerciaux] = useState([]);
      const [peridoe,setPeriode] = useState("date");
      const [selectOptionCommercial,setSelectOptionCommercial] = useState(null);
      const [objectifCashIn,setObjectifCashIn] = useState(0);
      const [objectifCashOut,setObjectifCashOut] = useState(0);
      const [loading,setLoading] = useState(false);
      const [loading1,setLoading1] = useState(false);
      const [dateChoose,setDateChoose] = useState(null);

      const {user,role, permissions} = useContext(UserContext);
      const navigate = useNavigate();
      useEffect(()=>{
        if(user && permissions && !can(permissions,'VENTE MOMO COMMERCIAUX')){
            navigate('/page-no-found');
        }
      },[user]);

      useEffect(()=>{
        fetchCommerciaux();
      },[venteSerie]);

      const fetchCommerciaux = async ()=>{
        // setLoading(true);
        try {
            axios.get(url.base+'/commerciaux',{
                headers:{
                    'Content-Type':'application/json',
                    "Authorization": `Bearer ${localStorage.getItem('_token_')}`
                    
                },
            }).then((resp)=>{
    
                if(resp.status == 200){
                  setCommerciaux(resp.data);
                }
            })
        } catch (error) {
            // setLoading(false);
        }
    }

    const fetchDataSynthese = async ()=>{

      if(peridoe != "" && selectOptionCommercial != null){
        setVendeurEvd([]);
        setVenteSerie([]);

        if(dateChoose == null && peridoe == "date"){
          SwalTopEnd({icon:'error',title:'Désolé, veuillez choisir la date.'});
          return;
        }
        setLoading(true);
        try {
            axios.post(url.base+'/momo-by-sellers',{periode:peridoe,num_commercial:selectOptionCommercial,date_choose:dateChoose},{
                headers:{
                    'Content-Type':'application/json',
                    "Authorization": `Bearer ${localStorage.getItem('_token_')}`
                    
                },
            }).then((resp)=>{
    
              setTotalAirtime(resp.data.totalCashin);
              setTotalBundle(resp.data.totalCashout);
              setTotalCashBack(resp.data.NbreCashin);
              setNbreCashout(resp.data.NbreCashout);
              const labelMoisArr = Object.keys(resp.data.labels).map(key => resp.data?.labels[key]);

              const transformedData = labelMoisArr.map((month, index) => ({
                day: month,
                CashIN: resp.data?.venteSerieCashIN[month] || 0,  
                CashOut: resp.data?.venteSerieCashOut[month] || 0,  

              }));

              console.log(transformedData);


              setVenteSerie(transformedData);
                
                setLoading(false);
            })
        } catch (error) {
            setLoading(false);
        }
      }else{
        SwalTopEnd({icon:'error',title:'La période ou commercial vide'});
      }

  }

  const fetchListPos = async ()=>{

    if(dateChoose == null && peridoe == "date"){
      SwalTopEnd({icon:'error',title:'Désolé, veuillez choisir la date.'});
      return;
    }

    setLoading1(true);
    try {
        axios.post(url.base+'/listvendeurs-momo-by-sellers',{periode:peridoe,num_commercial:selectOptionCommercial,date_choose:dateChoose},{
            headers:{
                'Content-Type':'application/json',
                "Authorization": `Bearer ${localStorage.getItem('_token_')}`
                
            },
        }).then((resp)=>{
          setLoading1(false);
          setVendeurEvd(resp.data.listePosVendeurs);
              setAllVendeurEvd(resp.data.listeAllPosVendeurs);
        })
    } catch (error) {
        setLoading1(false);
    }
}

    const optioncommerciaux = commerciaux?.map((option)=>({
      label:`${option?.NomCommercial}`,
      value:option?.NumeroMarchand,
      cashin:option?.ObjectifCashin,
      cashout:option?.ObjectifCashOut
    }));

    const handleChangeCommercial=(selectOption)=>{
      setSelectOptionCommercial(selectOption.value);
      setObjectifCashIn(selectOption.cashin);
      setObjectifCashOut(selectOption.cashout);
    }

    // console.log(venteSerie?.AIRTIME.map((item)=>item));



    return (
        <>
            <ContentPage>
            <div class="page-header flex-wrap">
                <div class="header-right d-flex flex-wrap mt-md-2 mt-lg-0">
                    <div class="d-flex align-items-center">
                    <a href="#">
                        <p class="m-0 pr-3">Page</p>
                    </a>
                    <a class="pl-3 mr-4" href="#">
                        <p class="m-0">Vente MOMO des commerciaux</p>
                    </a>
                    </div>
                    
                </div>
                <div class="header-left">
                  {/* <Link class="btn btn-primary mb-2 mb-md-0 mr-2" to="/parametres/add-commercial"> Ajouter un commercial</Link> */}
                  {/* <button class="btn btn-outline-primary mb-2 mb-md-0"> Import documents </button> */}
                </div>
              
            </div>

            <div class="col-lg-12 grid-margin stretch-card">
            <div class="card">
            <div class="card-header bg-warning bg-gradient">
                      <div class="row">
                        
                            <div className="col-4">
                                <Select placeholder="Commercial" options={optioncommerciaux} onChange={handleChangeCommercial}/>
                            </div>

                            <select className="col-3 mx-2 form-control text-dark" onChange={(e)=>{setPeriode(e.target.value);setDateChoose(null);}}>
                                <option value="date">Choisir une date</option>
                                <option value="semaine">Cette semaine</option>
                                <option value="mois">Ce mois</option>
                                <option value="last_month">Le mois dernier</option>
                                <option value="trimestre">Le Trimestre</option>
                                <option value="annee">Cette année</option>
                            </select>
                            {peridoe == "date" &&
                              <>
                              <input type="date" className="form-control m-2 " onChange={(e)=>setDateChoose(e.target.value)}/>
                              </>
                            }
                            <button class="btn btn-primary col-3" type="button" onClick={()=>fetchDataSynthese()}> Lancer la recherche </button>
                  </div>
              </div>
                </div>
              </div>

              <div class="row">
              <div class="col-sm-4 stretch-card grid-margin">
                <div class="card">
                  <div class="card-body">
                    <div class="d-flex justify-content-between">
                      <div class="card-title"> TOTAL VENTE MOMO  <small class="d-block text-muted"></small>
                      </div>
                      
                    </div>
                    <h3 class="font-weight-bold mb-0 text-success"> 
                      {!loading ? separateNumber(TotalAirtime+TotalBundle)  :
                        <div class="spinner-grow" style={{"width": "3rem", "height": "3rem"}} role="status">
                          <span class="visually-hidden"></span>
                        </div>
                      } FCFA
                    
                       {/* <span class="text-success h5">4,5%<i class="mdi mdi-arrow-up"></i></span> */}
                    </h3>
                    {/* <span class="text-muted font-13">Somme des ventes Airtime</span> */}
                    {/* <div class="line-chart-wrapper">
                      <canvas id="linechart" height="80"></canvas>
                    </div> */}
                  </div>
                </div>
              </div>
              <div class="col-sm-4 stretch-card grid-margin">
                <div class="card">
                  <div class="card-body">
                    <div class="d-flex justify-content-between">
                      <div class="card-title"> TOTAL VENTE CASH IN
                        <small class="d-block text-muted"></small>
                      </div>
                    
                    </div>
                    <h3 class="font-weight-bold mb-0 text-danger"> 
                    {!loading ? separateNumber(TotalAirtime)  :
                        <div class="spinner-grow" style={{"width": "3rem", "height": "3rem"}} role="status">
                          <span class="visually-hidden"></span>
                        </div>
                      } FCFA
                      {/* <span class="text-success h5">0.20%<i class="mdi mdi-arrow-up"></i></span> */}
                    </h3>
                    {/* <span class="text-muted font-13">Somme des ventes bundle</span> */}
                    {/* <div class="bar-chart-wrapper">
                      <canvas id="barchart" height="80"></canvas>
                    </div> */}
                  </div>
                </div>
              </div>
              <div class="col-sm-4 stretch-card grid-margin">
                <div class="card">
                  <div class="card-body">
                    <div class="d-flex justify-content-between">
                      <div class="card-title"> TOTAL VENTE CASH OUT
                        <small class="d-block text-muted"></small>
                      </div>
                     
                    </div>
                    <h3 class="font-weight-bold mb-0 text-success" > 
                    {!loading ? separateNumber(TotalBundle)  :
                        <div class="spinner-grow" style={{"width": "3rem", "height": "3rem"}} role="status">
                          <span class="visually-hidden"></span>
                        </div>
                      } FCFA
                      {/* <span class="text-success h5">0.20%<i class="mdi mdi-arrow-up"></i></span> */}
                    </h3>
                    {/* <span class="text-muted font-13">
                      somme des ventes cash back v2
                    </span> */}
                    {/* <div class="bar-chart-wrapper">
                      <canvas id="barchart" height="80"></canvas>
                    </div> */}
                  </div>
                </div>
              </div>
            </div> 

            <div class="row">
                <div class="col-xl-12 stretch-card grid-margin">
                  <div class="card">
                    <div class="card-body">
                      <div class="d-flex justify-content-between flex-wrap">
                        <div>
                          <div class="card-title mb-0">TOTAL CASH IN</div>
                          <h3 class="font-weight-bold mb-0 text-success">{separateNumber(TotalAirtime)} FCFA</h3>
                        </div>
                        <div>
                          <div class="d-flex flex-wrap pt-2 justify-content-between sales-header-right">
                            <div class="d-flex mr-5">
                              <button type="button" class="btn btn-social-icon btn-outline-sales">
                                <i class="mdi mdi-inbox-arrow-down"></i>
                              </button>
                              <div class="pl-2">
                                <h4 class="mb-0 font-weight-semibold head-count"> {separateNumber(objectifCashIn)} FCFA</h4>
                                <span class="font-10 font-weight-semibold text-muted">OBJECTIF CASH IN</span>
                              </div>
                            </div>
                             {/*<div class="d-flex mr-3 mt-2 mt-sm-0">
                              <button type="button" class="btn btn-social-icon btn-outline-sales profit">
                                <i class="mdi mdi-cash text-info"></i>
                              </button>
                              <div class="pl-2">
                                <h4 class="mb-0 font-weight-semibold head-count"> 1.079.000 </h4>
                                <span class="font-10 font-weight-semibold text-muted">TOTAL BUNDLE</span>
                              </div>
                            </div> */}
                            <div class="d-flex mr-3 mt-2 mt-sm-0">
                              <button type="button" class="btn btn-social-icon btn-outline-sales profit">
                                <i class="mdi mdi-cash text-info"></i>
                              </button>
                              <div class="pl-2">
                                <h4 class="mb-0 font-weight-semibold head-count"> {((TotalAirtime)*100/objectifCashIn).toFixed(2) ??0}%</h4>
                                <span class="font-10 font-weight-semibold text-muted">POURCENTAGE</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <p class="text-muted font-13 mt-2 mt-sm-0"> 
                      </p>
                      <div class="flot-chart-wrapper">

                      
                      <div style={{ backgroundColor: "#1e1e2f", padding: "20px", borderRadius: "10px" }}>
                      {venteSerie && 
                        <ResponsiveContainer width="100%" height={400}>
                        <AreaChart data={venteSerie} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
                          <defs>
                            <linearGradient id="colorBalance1" x1="0" y1="0" x2="0" y2="1">
                              <stop offset="0%" stopColor="#33FF33" stopOpacity={0.8} />
                              <stop offset="100%" stopColor="#33FF33" stopOpacity={0} />
                            </linearGradient>
                            <linearGradient id="colorBalance2" x1="0" y1="0" x2="0" y2="1">
                              <stop offset="0%" stopColor="#3399FF" stopOpacity={0.8} />
                              <stop offset="100%" stopColor="#3399FF" stopOpacity={0} />
                            </linearGradient>
                            <linearGradient id="colorBalance3" x1="0" y1="0" x2="0" y2="1">
                              <stop offset="0%" stopColor="#FF9933" stopOpacity={0.8} />
                              <stop offset="100%" stopColor="#FF9933" stopOpacity={0} />
                            </linearGradient>
                          </defs>
                          <CartesianGrid strokeDasharray="3 3" stroke="#3c3c3c" />
                          <XAxis dataKey="day" tick={{ fill: "#ccc" }} />
                          <YAxis tick={{ fill: "#ccc" }} />
                          <Tooltip
                            contentStyle={{
                              backgroundColor: "#333",
                              border: "none",
                              color: "#fff",
                            }}
                          />
                          <Area
                            type="monotone"
                            dataKey="CashIN"
                            stroke="#33FF33"
                            fill="url(#colorBalance1)"
                            strokeWidth={2}
                          />
                         
                          <Area
                            type="monotone"
                            dataKey="CASHBACK"
                            stroke="#FF9933"
                            fill="url(#colorBalance3)"
                            strokeWidth={2}
                          />
                        </AreaChart>
               
                </ResponsiveContainer>
                      }
                      </div>

                      </div>
                    </div>
                  </div>
                </div>
              
            </div>

            <div class="row">
                <div class="col-xl-12 stretch-card grid-margin">
                  <div class="card">
                    <div class="card-body">
                      <div class="d-flex justify-content-between flex-wrap">
                        <div>
                          <div class="card-title mb-0">TOTAL CASH OUT</div>
                          <h3 class="font-weight-bold mb-0 text-success">{separateNumber(TotalBundle)} FCFA</h3>
                        </div>
                        <div>
                          <div class="d-flex flex-wrap pt-2 justify-content-between sales-header-right">
                            <div class="d-flex mr-5">
                              <button type="button" class="btn btn-social-icon btn-outline-sales">
                                <i class="mdi mdi-inbox-arrow-down"></i>
                              </button>
                              <div class="pl-2">
                                <h4 class="mb-0 font-weight-semibold head-count"> {separateNumber(objectifCashOut)} FCFA</h4>
                                <span class="font-10 font-weight-semibold text-muted">OBJECTIF MOMO</span>
                              </div>
                            </div>
                             {/*<div class="d-flex mr-3 mt-2 mt-sm-0">
                              <button type="button" class="btn btn-social-icon btn-outline-sales profit">
                                <i class="mdi mdi-cash text-info"></i>
                              </button>
                              <div class="pl-2">
                                <h4 class="mb-0 font-weight-semibold head-count"> 1.079.000 </h4>
                                <span class="font-10 font-weight-semibold text-muted">TOTAL BUNDLE</span>
                              </div>
                            </div> */}
                            <div class="d-flex mr-3 mt-2 mt-sm-0">
                              <button type="button" class="btn btn-social-icon btn-outline-sales profit">
                                <i class="mdi mdi-cash text-info"></i>
                              </button>
                              <div class="pl-2">
                                <h4 class="mb-0 font-weight-semibold head-count"> {((TotalBundle)*100/objectifCashOut).toFixed(2) ??0}%</h4>
                                <span class="font-10 font-weight-semibold text-muted">POURCENTAGE</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <p class="text-muted font-13 mt-2 mt-sm-0"> 
                      </p>
                      <div class="flot-chart-wrapper">

                      
                      <div style={{ backgroundColor: "#1e1e2f", padding: "20px", borderRadius: "10px" }}>
                      {venteSerie && 
                        <ResponsiveContainer width="100%" height={400}>
                        <AreaChart data={venteSerie} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
                          <defs>
                            <linearGradient id="colorBalance1" x1="0" y1="0" x2="0" y2="1">
                              <stop offset="0%" stopColor="#33FF33" stopOpacity={0.8} />
                              <stop offset="100%" stopColor="#33FF33" stopOpacity={0} />
                            </linearGradient>
                            <linearGradient id="colorBalance2" x1="0" y1="0" x2="0" y2="1">
                              <stop offset="0%" stopColor="#3399FF" stopOpacity={0.8} />
                              <stop offset="100%" stopColor="#3399FF" stopOpacity={0} />
                            </linearGradient>
                            <linearGradient id="colorBalance3" x1="0" y1="0" x2="0" y2="1">
                              <stop offset="0%" stopColor="#FF9933" stopOpacity={0.8} />
                              <stop offset="100%" stopColor="#FF9933" stopOpacity={0} />
                            </linearGradient>
                          </defs>
                          <CartesianGrid strokeDasharray="3 3" stroke="#3c3c3c" />
                          <XAxis dataKey="day" tick={{ fill: "#ccc" }} />
                          <YAxis tick={{ fill: "#ccc" }} />
                          <Tooltip
                            contentStyle={{
                              backgroundColor: "#333",
                              border: "none",
                              color: "#fff",
                            }}
                          />
                          <Area
                            type="monotone"
                            dataKey="CashOut"
                            stroke="#3399FF"
                            fill="url(#colorBalance2)"
                            strokeWidth={2}
                          />
                          <Area
                            type="monotone"
                            dataKey="CASHBACK"
                            stroke="#FF9933"
                            fill="url(#colorBalance3)"
                            strokeWidth={2}
                          />
                        </AreaChart>
               
                </ResponsiveContainer>
                      }
                      </div>

                      </div>
                    </div>
                  </div>
                </div>
              
            </div>

            {(TotalAirtime+TotalBundle+TotalCashBack) > 0 && selectOptionCommercial != null && peridoe !="" &&
                <div class="col-lg-12 grid-margin stretch-card">
                    <div class="card">
                      <div class="card-header bg-secondary bg-gradient">
                                <div class="row">                       
                                  
                                      <button class="btn btn-primary col-4 mx-2" type="button" onClick={()=>fetchListPos()}> 
                                      {!loading1 ? "Afficher la liste des POS du commercial"  :
                                        <div class="spinner-grow" style={{"width": "3rem", "height": "3rem"}} role="status">
                                          <span class="visually-hidden"></span>
                                        </div>
                                      }
                                      </button>
                                      {/* <button class="btn btn-success col-4 mx-2" type="button" > Télécharger la liste des POS du commercial</button> */}
                            </div>
                        </div>
                    </div>
                  </div>
            }

            {vendeurEvd?.length > 0 && (TotalAirtime+TotalBundle+TotalCashBack) > 0 && selectOptionCommercial != null && peridoe !="" &&
             <div class="row">
             <div class="col-xl-12 stretch-card grid-margin">
               <div class="card">
                 <div class="card-body">
                   <div class="d-flex justify-content-between flex-wrap">
                     <div>
                       <div class="card-title mb-0">LISTE DES POS DU COMMERCIAL
                        
                       </div>
                       <ExportExcel excelData={vendeurEvd} filename={"Classement Ventes POS commercial XLSX"} title={"Télécharger le classement des POS du commercial"} color={'btn-success'} />
                       <ExportExcel excelData={AllvendeurEvd} filename={"Detail ventes des POS XLSX"} title={"Télécharger la liste des ventes POS du commercial"} color={'btn-danger'}/>

                       {/* <h3 class="font-weight-bold mb-0">2.371.500</h3> */}
                     </div>
                     <div>
                       <div class="d-flex flex-wrap pt-2 justify-content-between sales-header-right">

                       </div>
                     </div>
                   </div>
                   {/* <p class="text-muted font-13 mt-2 mt-sm-0"> Total vente de la semaine en cours
                   </p> */}
                   <div class="flot-chart-wrapper">

                   <div class="table-responsive">
                   <table class="table table-striped">
                     <thead> 
                       <tr>
                         <th>NOM DU PDV</th>
                         <th>NUMERO</th>
                         <th>NBRE CASH IN</th>
                         <th>NBRE CASH OUT</th>
                         <th>VENTE CASHIN</th>
                         <th>VENTE CASHOUT</th>
                         <th className="text-center">TOTAL VENDU</th>
                         <th>DUREE</th>
                       </tr>
                     </thead>
                     <tbody>
                     {vendeurEvd.map((pos, index) => (
                       <tr key={index}>
                         <td class="py-1">
                           <img src="../../../assets/images/dashboard/img_3.jpg" alt="image"/>
                           {pos.NomPDV}
                         </td>
                         <td>{pos.MSISDN_NSK}</td>                       
                          <td className="text-center">{pos.nbreCashIN}</td> 
                         <td className="text-center">{pos.nbreCashOut}</td> 
                         <td className="text-center">{separateNumber(pos.CashIN)}</td> 
                         <td className="text-center">{separateNumber(pos.CashOut)}</td> 
                         <td className="text-center">
                             <b className="text-danger">{separateNumber(pos.total) }</b>
                         </td>   
                         <td>
                            {peridoe == "jour" && <span>Une journée</span>}
                            {peridoe == "semaine" && <span>Une semaine</span>}
                            {peridoe == "mois" | peridoe == "last_month" ? <span>Un mois</span>:""}
                            {peridoe == "annee" && <span>Une année</span>}
                            {peridoe == "trimestre" && <span>Le Trimestre</span>}
                        </td>                        
                       </tr>
                     ))}
                     </tbody>
                   </table>
                 </div>
                
                   </div>
                 </div>
               </div>
             </div>
           
         </div>
            
            }
           

               
            </ContentPage>
        </>
    )
}
export default MomoCommercialPage;